import type { Drug } from "../types";

export const fusidicAcidDrug: Drug = {
  id: "fusidic_acid_cream",
  name: "Fusidic acid 2% cream",
  drugClass: "antibiotic_topical",
  defaultFoodTiming: "For topical use only",
  formulations: [
    {
      id: "fusidic-2pct-15g",
      type: "topical_cream",
      strength: 2,
      strengthUnit: "%",
      tubeSize: 15,
      tubeSizeUnit: "g",
    },
    {
      id: "fusidic-2pct-30g",
      type: "topical_cream",
      strength: 2,
      strengthUnit: "%",
      tubeSize: 30,
      tubeSizeUnit: "g",
    },
  ],
};
